// `AWAITING_CLOSING` é anterior ao `PENDING`: o vale já nasceu, mas só entra na
// fila do RH quando o Analista fecha a conciliação (ADR-PAY-005 da API). O RH nunca
// recebe vale nesse estado — a chave existe para o enum espelhar o domínio e o
// compilador cobrar quem listar status à mão.
export enum PayrollVoucherStatusEnum {
  AWAITING_CLOSING = "AWAITING_CLOSING",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export const PAYROLL_VOUCHER_STATUS_LABELS: Record<
  PayrollVoucherStatusEnum,
  string
> = {
  [PayrollVoucherStatusEnum.AWAITING_CLOSING]: "Aguardando fechamento",
  [PayrollVoucherStatusEnum.PENDING]: "Aguardando",
  [PayrollVoucherStatusEnum.APPROVED]: "Aprovado",
  [PayrollVoucherStatusEnum.REJECTED]: "Reprovado",
};
